export enum NodeTypes {
  NODE_APPROVALS = 'NODE_APPROVALS',
  NODE_CONDITION = 'NODE_CONDITION',
  NODE_TRIGGER = 'NODE_TRIGGER',
  NODE_SELECT = 'NODE_SELECT',
}
